import styled from "@emotion/styled";
import {
  generateInputFieldStyles,
  generateTextStyles,
  getCircleIconStyles,
} from "../../utils";
import { CircleIconProps, InputFieldInputProps } from "./InputField.types";
import { colorPalette } from "../../theme/colors";

export const InputFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const InputFieldWrapper = styled.div<InputFieldInputProps>`
  display: flex;
  width: 100%;
  position: relative;
  border-radius: 8px;
  ${(props) => generateInputFieldStyles(props)};
  max-width: 448px;
`;

export const InputFieldLabel = styled.label`
  position: absolute;
  top: 14%;
  left: 16px;
  pointer-events: none;
  display: block;
  margin: 0;
  padding: 0;
  line-height: normal;

  ${generateTextStyles({
    type: "caps",
    fontWeight: "semiBold",
    variant: 2,
    color: colorPalette.popBlack[100],
  })}
`;

export const InputFieldSpan = styled.span`
  color: ${colorPalette.error[500]};
`;

export const InputFieldInput = styled.input<InputFieldInputProps>`
  width: 100%;
  border-radius: 8px;
  box-sizing: border-box;
  height: 60px;
  padding: ${(props) =>
    props.value || props.isFocused ? "28px 16px 8px 16px" : "16px"};
  border: none;
  background: transparent;
  ${generateTextStyles({
    type: "body",
    fontWeight: "medium",
    variant: 4,
    color: colorPalette.popBlack[500],
  })}
  cursor: ${(props) => (props.readOnly ? "pointer" : "default")};

  &:focus {
    outline: none;
  }

  ::placeholder {
    ${generateTextStyles({
      type: "body",
      fontWeight: "medium",
      variant: 4,
      color: colorPalette.popBlack[100],
    })}
  }
`;

export const DropdownSelectedValue = styled.div<
  Pick<InputFieldInputProps, "value">
>`
  width: 100%;
  border-radius: 8px;
  box-sizing: border-box;
  height: 60px;
  padding: ${(props) => (props.value ? "28px 14px 8px 14px" : "14px")};
  border: none;
  background: transparent;
  ${generateTextStyles({
    type: "body",
    fontWeight: "medium",
    variant: 4,
    color: colorPalette.popBlack[500],
  })}
`;

export const InputFieldPlaceholder = styled.span`
  position: absolute;
  top: 22px;
  left: 16px;
  margin: 0;
  padding: 0;
  pointer-events: none;
  ${generateTextStyles({
    type: "body",
    fontWeight: "medium",
    variant: 4,
    color: colorPalette.popBlack[100],
  })}
`;

export const InputFieldUtil = styled.div`
  position: relative;
  width: 63px;
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 10px 16px;
  flex-direction: column;
  flex-shrink: 0;
`;

export const InputFieldUtilWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
`;

export const CloseIconWrapper = styled.div<{ isFocused: boolean }>`
  position: absolute;
  top: ${(props) => (props.isFocused ? "28px" : "24px")};
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
`;

export const CloseIcon = styled.i`
  color: ${colorPalette.popBlack[100]};
`;

export const CircleIcon = styled.i<CircleIconProps>`
  ${(props) => getCircleIconStyles(props)}
  margin: 4px 14px 0 4px;
  font-size: 12px;
`;

export const CharacterCountWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  ${() =>
    generateTextStyles({
      type: "caps",
      fontWeight: "semiBold",
      variant: 2,
      color: colorPalette.black[100],
    })}
`;

export const SupportingText = styled.div<CircleIconProps>`
  display: flex;
  margin-top: 8px;
  align-items: flex-start;
  justify-content: flex-start;

  ${(props) => getCircleIconStyles(props)}
`;

export const DropdownIcon = styled.i`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: ${colorPalette.success[500]};
`;
